export interface ProductoAreaConocimientoDTO{
    iddecinvproductoareaconocimiento: number, 
    iddecinvproyectoprodtermin: number, 
    iddecinvtipoproductoesperado: number, 
    codarea: number, 
    codsubarea: number, 
    codsubareadetallada: number,
    ultimoCambio:string,
}

export function getVoidProductoAreaConocimientoDTO(): ProductoAreaConocimientoDTO{
    return{
        iddecinvproductoareaconocimiento: 0, 
        iddecinvproyectoprodtermin: 0, 
        iddecinvtipoproductoesperado: 0, 
        codarea: 0, 
        codsubarea: 0, 
        codsubareadetallada: 0,
        ultimoCambio:'',
    }
}

export function setProductoAreaConocimientoDTO(data: any): ProductoAreaConocimientoDTO{
    return{ 
        iddecinvproductoareaconocimiento: data.iddecinvproductoareaconocimiento??0,
	    iddecinvproyectoprodtermin: data.iddecinvproyectoprodtermin??0,
	    iddecinvtipoproductoesperado: data.iddecinvtipoproductoesperado??0,
	    codarea: data.codarea??0,
        codsubarea: data.codsubarea??0, 
        codsubareadetallada: data.codsubareadetallada??0,
        ultimoCambio:data.ultimocambio,
    }
}